export const mockProducts = [
  {
    id: "m1",
    name: "Afgan 9pm",
    price: 60000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254813/ad248d39-aa80-44a8-9928-111573bf73d2_n0udqd.jpg",
    category: "Signature",
    description: "A rich, warm oriental fragrance",
    featured: true,
  },
  {
    id: "m2",
    name: "Club de Nuit",
    price: 60000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254803/021f08bb-47a7-47c8-ab90-d97ad3f0a5e4_z3qq0w.jpg",
    category: "Oud",
    description: "Intense woody night scent",
    featured: true,
  },
  {
    id: "m3",
    name: "Vintage Radio",
    price: 50000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254821/05b9073b-cc58-4f1c-9723-09ca10f20d83_cmdmy4.jpg",
    category: "Floral",
    description: "A timeless floral bouquet",
    featured: true,
  },
  {
    id: "m4",
    name: "Stronger With YOU",
    price: 201000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254807/5144e99d-ed10-4559-be8a-633ee3e53eba_e6joua.jpg",
    category: "Woody",
    description: "Bold, confident, magnetic",
    featured: true,
  },
  {
    id: "m5",
    name: "Khmrah Dukham",
    price: 43000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254821/4dc31ac4-a235-4772-9bb8-ccde3320626a_hwdjvn.jpg",
    category: "Arabic",
    description: "Exotic middle-eastern blend",
    featured: true,
  },
  {
    id: "m6",
    name: "Her Confession",
    price: 50000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254805/408e1a70-a354-4f66-b149-5e9692bd32ea_w9s1lx.jpg",
    category: "Floral",
    description: "Soft, feminine, unforgettable",
    featured: true,
  },
  {
    id: "m7",
    name: "Sauvage EDP",
    price: 85000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254814/af2e56f2-2cbc-47c6-a6fa-8f5e79ba3ddb_mi5pk6.jpg",
    category: "Fresh",
    description: "Fresh spicy scent",
    featured: false,
  },
  {
    id: "m8",
    name: "Supremacy Collector's Edition",
    price: 95000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254808/40794b8d-c991-42e6-baa4-6cf6d2dc2d83_ahnqq5.jpg",
    category: "Woody",
    description: "Smoky woody blend",
    featured: false,
  },
  {
    id: "m9",
    name: "Rave Black",
    price: 30000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254802/8ec52e3a-9b40-40bd-b73a-86f5246d6eb2_t4jh5o.jpg",
    category: "Arabic",
    description: "Dark sweet musk",
    featured: false,
  },
  {
    id: "m10",
    name: "Floriana by Rayhaan",
    price: 32000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254818/f9e3eb29-1c17-4060-9bdb-2eaeb04939e4_ryeskn.jpg",
    category: "Floral",
    description: "Soft floral sweet",
    featured: false,
  },
  {
    id: "m11",
    name: "Vanilla Voyage",
    price: 50000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254810/69470109-95e8-4613-a5c1-f3c40114dc02_ed97ut.jpg",
    category: "Signature",
    description: "Creamy vanilla warm",
    featured: false,
  },
  {
    id: "m12",
    name: "Nebras by Lattafa",
    price: 45000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254812/a1c72b3e-cef9-4541-aa80-f40c24bcdc58_yuesql.jpg",
    category: "Signature",
    description: "Sweet cocoa vanilla",
    featured: false,
  },
  {
    id: "m13",
    name: "Ishq Al Shuyukh",
    price: 45000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254808/6078101c-b89b-4303-abde-8b0d6f14094d_faamxf.jpg",
    category: "Arabic",
    description: "Rich oud spice",
    featured: false,
  },
  {
    id: "m14",
    name: "Angham by Lattafa",
    price: 40000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254818/e55789c6-af6d-4c5a-a400-07de1ff75444_sq2vwk.jpg",
    category: "Floral",
    description: "Soft floral musk",
    featured: false,
  },
  {
    id: "m15",
    name: "Marshmallow Blush",
    price: 55000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254802/7a1e1b72-eada-4c50-ae0a-b96a786f3d6f_fkejop.jpg",
    category: "Floral",
    description: "Sweet candy floral",
    featured: false,
  },
  {
    id: "m16",
    name: "Rayhaan Crimson",
    price: 201000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254809/55204433-b735-4fdd-96d2-c3b7bacb541b_fjt8hv.jpg",
    category: "Woody",
    description: "Spicy woody bold",
    featured: false,
  },
  {
    id: "m17",
    name: "Khamrah Dukhan",
    price: 43000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254819/fda92ac9-185c-4155-96cc-2546c6d0126a_vfedzh.jpg",
    category: "Arabic",
    description: "Smoky sweet amber",
    featured: false,
  },
  {
    id: "m18",
    name: "Musamam White",
    price: 50000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254803/97af0fc9-e9cc-443f-b9e7-6b6f9031b83f_dkzei9.jpg",
    category: "Fresh",
    description: "Clean light musk",
    featured: false,
  },
  {
    id: "m19",
    name: "Fire on ICE",
    price: 45000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254816/b9ce1505-a195-4bdf-b987-447523e73ccd_fqk4bv.jpg",
    category: "Fresh",
    description: "Cool spicy mix",
    featured: false,
  },
  {
    id: "m20",
    name: "Yara Elixir",
    price: 36000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254811/a0f18489-7475-49a2-8fb3-9d58e731e27a_ady0wr.jpg",
    category: "Floral",
    description: "Fruity floral sweet",
    featured: false,
  },
  {
    id: "m21",
    name: "Ignite Oud",
    price: 95000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254807/520e4791-f649-4352-9bc0-734639aed6d6_dnjrgb.jpg",
    category: "Oud",
    description: "Strong smoky oud",
    featured: false,
  },
  {
    id: "m22",
    name: "Qaed Al Fursan",
    price: 32000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254803/30e00069-0b2e-4e11-b032-58566d34bd8b_w9mzck.jpg",
    category: "Woody",
    description: "Fruity woody bold",
    featured: false,
  },
  {
    id: "m23",
    name: "Layaan",
    price: 35000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254815/b07beb80-db98-479f-967d-73432c8d9d18_x4uftu.jpg",
    category: "Floral",
    description: "Soft sweet floral",
    featured: false,
  },
  {
    id: "m24",
    name: "Spectra Ghosts",
    price: 60000,
    image_url: "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254802/9f922d26-06ad-4e76-b176-5812f9d58ec2_scdutc.jpg",
    category: "Signature",
    description: "Fresh sweet musk",
    featured: false,
  },
];
